import { DataState } from 'types/store/reducers/dataSources';

import { normalizeById } from 'store/utils';
import { Client } from 'types';
import { ClientActions } from 'types/store/actions/clients';
import { ClientActionTypes } from 'types/store/actions/constants';

export const initialState: DataState<Client> = {
  data: {},
};

export default (
  state = initialState,
  action: ClientActions
): DataState<Client> => {
  switch (action.type) {
    case ClientActionTypes.RESET:
      return initialState;

    case ClientActionTypes.LIST_ALL_SUCCESS:
    case ClientActionTypes.LIST_SUCCESS: {
      const { records } = action.payload;
      const normalizedData = normalizeById(records);
      return {
        ...state,
        data: { ...state.data, ...normalizedData },
      };
    }
    default:
      return state;
  }
};
